// extracted by mini-css-extract-plugin
export default {"table":"Controls_table__5zNJM","search":"Controls_search__d8Bo-"};